<template>
    <section class="block blog-cat">
        <div class="wrap">
            <div class="blog-toolbar" v-if="tags.length || meta.total">
                <div class="blog-filters" v-if="tags.length">
                    <button type="button" :class="{ active: activeTag === null }" @click="selectTag(null)">
                        Todos
                    </button>
                    <button type="button" v-for="tag in tags" :key="tag"
                        :class="{ active: activeTag === tag }" @click="selectTag(tag)">
                        {{ tag }}
                    </button>
                </div>
                <Pagination v-model="filters" :meta="meta" />
            </div>

            <div v-if="status.get" class="blog-cat-grid">
                <div v-for="n in skeletonCount" :key="'sk' + n" class="post post--sk" aria-hidden="true">
                    <div class="p-img rino-sk"></div>
                    <div class="rino-sk rino-sk-line rino-sk-line--sm" style="width:30%"></div>
                    <div class="rino-sk rino-sk-line" style="width:90%"></div>
                    <div class="rino-sk rino-sk-line rino-sk-line--sm" style="width:70%"></div>
                </div>
            </div>
            <BlogNotes v-else :notes="posts" />

            <div class="blog-empty" :class="{ show: !status.get && posts.length === 0 }">
                No hay artículos en esta categoría todavía.
            </div>

            <Pagination v-model="filters" :meta="meta" class="pagination-bottom" />
        </div>
    </section>
</template>
<script>
import axios from 'axios';
import BlogNotes from './BlogNotes.vue';
import Pagination from './Pagination.vue';
import { useAwn } from '/composables/useAwn';

const API_KEY = 'NPP3dB1ch8CiEmRGprtB2Vpr7xbZdA7iUnw7gX7ORjXdX0vzQ';

export default {
    components: { BlogNotes, Pagination },
    data() {
        return {
            posts: [],
            tags: [],
            activeTag: null,
            meta: {},
            awn: null,
            status: { get: false },
            filters: {
                pageSize: 9,
                page: 1,
                tag: null
            }
        }
    },
    computed: {
        skeletonCount() {
            return Number(this.filters.pageSize) || 9
        }
    },
    watch: {
        filters: {
            handler() { this.getPosts() },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        this.awn = useAwn();
    },
    methods: {
        getPosts() {
            this.status.get = true;
            axios.get('/api/public/v1/post', {
                params: this.removeNulls(this.filters),
                headers: { 'x-api-key': API_KEY }
            }).then(response => {
                this.posts = response.data.data || [];
                this.meta = response.data.meta || {};
                this.collectTags(this.posts);
            }).catch(() => {
                if (this.awn) this.awn.warning('No se han podido obtener los artículos');
            }).finally(() => {
                this.status.get = false;
            });
        },

        collectTags(posts) {
            if (this.tags.length) return;
            const seen = new Set();
            (posts || []).forEach(post => {
                (post.tags || []).forEach(tag => {
                    if (tag) seen.add(tag);
                });
            });
            this.tags = Array.from(seen.values());
        },

        selectTag(tag) {
            this.activeTag = tag;
            this.filters.tag = tag;
            this.filters.page = 1;
        },

        removeNulls(obj) {
            return Object.fromEntries(
                Object.entries(obj).filter(([_, value]) => value !== null && value !== undefined)
            );
        }
    }
}
</script>

<style>
/* Skeleton loaders del catálogo de blog (mientras carga la API) */
.post--sk{cursor:default;pointer-events:none;}
.rino-sk{position:relative;overflow:hidden;background:#ece9e2;border-radius:8px;}
.rino-sk::after{content:"";position:absolute;inset:0;transform:translateX(-100%);background:linear-gradient(90deg,transparent,rgba(255,255,255,.65),transparent);animation:rinoSkShimmer 1.3s ease-in-out infinite;}
.post--sk .p-img.rino-sk{width:100%;}
.rino-sk-line{height:22px;margin-top:12px;border-radius:6px;}
.rino-sk-line--sm{height:15px;margin-top:10px;}
@keyframes rinoSkShimmer{to{transform:translateX(100%);}}
@media (prefers-reduced-motion:reduce){.rino-sk::after{animation:none;}}
</style>
